/*
 * Globalize Culture da-DK
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
    let Globalize;

    if (
        typeof require !== 'undefined' &&
        typeof exports !== 'undefined' &&
        typeof module !== 'undefined'
    ) {
        // Assume CommonJS
        Globalize = require('globalize');
    } else {
        // Global variable
        Globalize = window.Globalize;
    }

    Globalize.addCultureInfo('da-DK', 'default', {
        name: 'da-DK',
        englishName: 'Danish (Denmark)',
        nativeName: 'dansk (Danmark)',
        language: 'da',
        numberFormat: {
            ',': '.',
            '.': ',',
            negativeInfinity: '-INF',
            positiveInfinity: 'INF',
            percent: {
                ',': '.',
                '.': ',',
            },
            currency: {
                pattern: ['$ -n', '$ n'],
                ',': '.',
                '.': ',',
                symbol: 'kr.',
            },
        },
        calendars: {
            standard: {
                '/': '-',
                firstDay: 1,
                days: {
                    names: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
                    namesAbbr: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
                    namesShort: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
                },
                months: {
                    names: [
                        'januar',
                        'februar',
                        'marts',
                        'april',
                        'maj',
                        'juni',
                        'juli',
                        'august',
                        'september',
                        'oktober',
                        'november',
                        'december',
                        '',
                    ],
                    namesAbbr: [
                        'jan',
                        'feb',
                        'mar',
                        'apr',
                        'maj',
                        'jun',
                        'jul',
                        'aug',
                        'sep',
                        'okt',
                        'nov',
                        'dec',
                        '',
                    ],
                },
                AM: null,
                PM: null,
                patterns: {
                    d: 'dd-MM-yyyy',
                    D: 'd. MMMM yyyy',
                    I: 'd. MMMM',
                    t: 'HH:mm',
                    T: 'HH:mm:ss',
                    f: 'd. MMMM yyyy HH:mm',
                    F: 'd. MMMM yyyy HH:mm:ss',
                    M: 'd. MMMM',
                    Y: 'MMMM yyyy',
                },
            },
        },
    });
})(this);
